module.exports = __webpack_public_path__ + "img/regular_loan_overview_icon01.b13753de.svg";